import { Box, LinearProgress, styled } from "@mui/material";

export const FancyProgressWrapper = styled(Box)(() => ({
  position: "relative",
  width: "60%",
  transform: "translateX(-12px)",
}));

export const FancyProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: 14,
  borderRadius: 8,
  backgroundColor: "#001937",
  "& .MuiLinearProgress-bar": {
    borderRadius: 8,
    backgroundImage: `linear-gradient(to right, ${theme.palette.primary.light}, ${theme.palette.primary.main})`,
  },
}));

export const ProgressText = styled("div")(({ theme: _theme }) => ({
  fontWeight: 600,
  fontSize: "0.75rem",
  color: "#001937",
  lineHeight: "14px", // Match the progress bar height
}));
